

<!-- Navigation -->
<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
    <div class="container">
      <a class="navbar-brand" href="/main">HOME</a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        Menu
        <i class="fas fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="/info">INFO</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:location.href='/board/noticeboard/1'">NoticeBoard</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/project">Project</a>
          </li>
          <li class="nav-item">
            <!--
            <script>
              function goPost() {
                var f = document.createElement('form');
                f.setAttribute('method', 'post');
                f.setAttribute('action', 'http://localhost:4000/b_judge/1');
                document.body.appendChild(f);
                f.submit();
              }
            </script>
            <a class="nav-link" href="javascript:goPost();">Online Judge</a>
            -->
            <a class="nav-link" href="/board">Online Judge</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>